module.exports = "/static/assets/6109659703109e02be27d559070ca726.png";